export default '/build/33987c31.png'